<template>
    <div>
        <div style="padding: 0 20px;  ">
            <!--    新增角色按钮-->
            <div class="top" style="justify-content: space-between;">
                <div>
                    
                   <el-button type="primary" @click="openAdd" style="width: 68px">新增</el-button>
 
                </div>
        
            </div>
            <!--    角色信息表格-->
            <div>
                <el-table :data="tableData" v-loading="loading">
                    
                    <el-table-column label="编号" prop="dictCode"></el-table-column>
                    <el-table-column label="用法" prop="dictValue"></el-table-column>
                    <!--
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="del(scope.row)">删除</el-button>                           
                        </template>
                    </el-table-column>
                    -->
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="pageNum"
                        :page-size="pageSize"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
        <el-dialog title="新增" :visible.sync="dialogAddVisible" width="740px" :close-on-click-modal="false">
           
            <el-form :model="dictionaryAdd" label-width="100px" size="small" :rules="rule" ref="add" style="margin-top: 20px">
                
                <el-form-item label="编号:" prop="dictCode">
                    <el-input v-model="dictionaryAdd.dictCode" style="width: 240px"></el-input>
                </el-form-item>
                <el-form-item label="用法:" prop="dictValue">
                    <el-input v-model="dictionaryAdd.dictValue" style="width: 240px"></el-input>
                </el-form-item>
                
            </el-form>
            
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogAddVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmAdd">确 定</el-button>
            </span>
        </el-dialog>

     
    </div>
</template>

<script type="text/javascript">
    export default {
        
        data() {
            return {
                // token
                authorization:localStorage.getItem('authorization'),
                // 搜索数据
                query: {                    
                    bizType: 'DOSAGE_USAGE',                   
                },
               
                // 表格页
                pageNum: 1,
                pageSize: 10,
                total: 0,
                // loading
                loading: true,
                // 列表数据
                tableData: [],
                
                // 新增弹窗
                dialogAddVisible: false,
                // 表单验证
                rule:{
                    dictCode:[{required: true, message: '请输入编号', trigger: 'blur'}],                    
                    dictValue:[{required: true, message: '请输入用法', trigger: 'blur'}],
                },               
                dictionaryAdd: {
                   bizType: 'DOSAGE_USAGE',              
                   dictCode: '',
                   dictValue:'',                    
                },

            }
        },

        methods: {
            
            // 获取列表数据
            getData() {                               
                this.loading = true
                let params = {                    
                    bizType: 'DOSAGE_USAGE',                    
                }
                
                this.axios.get('/api-b/10051/100510/' + this.pageNum + '/' + this.pageSize,{
                    params:{
                        bizType: 'DOSAGE_USAGE', 
                    },
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data.list.length !== 0) {
                            this.tableData = res.data.data.list
                            this.total = res.data.data.total                            
                        } else {
                            this.$message.info('暂无用法')
                            this.tableData = []
                            this.total = 0
                        }
                    } else {
                        this.$message.error(res.data.message)
                        this.tableData = []
                        this.total = 0
                    }
                    this.loading = false
                }).catch(error => {
                    this.tableData = []
                    this.total = 0
                    this.loading = false
                })
                
            },            
            // 换页
            handlePageChange(val) {
                this.pageNum = val
                this.getData()
            },
            // 打开新增
            openAdd() {
                this.dialogAddVisible = true
                this.$nextTick(() => {
                    this.$refs.add.resetFields()
                    this.dictionaryAdd.bizType = 'DOSAGE_USAGE'
                })
            }, 
            
            // 确认新增
            confirmAdd() {
                this.$refs.add.validate(valid => {
                    if (valid) {
                        let params = {}
                        
                        params = {            
                            
                            bizType: 'DOSAGE_USAGE', 
                            dictCode: this.dictionaryAdd.dictCode,
                            dictValue: this.dictionaryAdd.dictValue,             
                        }
                           
                        this.axios.post('/api-b/10051/100511/',params,{
                            headers:{
                                Authorization: this.authorization
                            }
                        }).then(res => {
                            if (res.data.code === 10000) {
                                this.dialogAddVisible = false
                                this.$message.success(res.data.message)
                                this.getData()
                                this.$nextTick(() => {
                                    this.$refs.add.resetFields()
                                })
                            } else  {
                                this.$message.error(res.data.message)
                            }
                        })
                    }
                })
            },
            
            // 获取药材详情,打开编辑
            del(data) {
                let params = new FormData()
                params.append('productNo',data.productNo)
                this.axios.post('/api-b/10050/100087/',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.medicinalEdit = res.data.data                   
                        this.dialogEditVisible = true                        
                    } else {
                        this.$message.error(res.data.message)
                    }
                })              
            },

        },
        watch: {
            query: {
                handler() {
                    this.pageNum = 1
                    clearTimeout(this.timeout);
                    this.timeout = setTimeout(() => {
                        this.getData();
                    }, 300);
                },
                deep:true
            },
            
        },
        created() {            
            this.getData()          
            
        }
    }

</script>


<style>
    .el-button--small {
        width: 65px;
        height: 32px;
        font-size: 14px;
    }
    .el-button--primary:hover {
        background:rgba(120,180,255,1)!important;
        color: #FFFFFF!important;
        border: none!important;
    }
    .el-button--primary:focus {
        background:rgba(57,129,221,1)!important;
        color: #FFFFFF!important;
        border: none!important;
    }
    .el-upload{
        border: none!important;
    }
    .el-upload--text {
        border: none!important;
    }
</style>

<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin-top: 12px;
        height: 52px;
    }
    .delete-button {
        margin-left: 20px;
        color: rgba(255,75,75,1) !important;
    }
    .delete-button:hover {
        color: rgba(255,75,75,0.8) !important;
    }
    .delete-button:focus {
        color: rgba(215,37,41,1) !important;
    }
    .dialog-set{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
    }
    .select-box {
        display: flex;
        flex-direction: row;
        height: 36px;
        line-height:36px;
        margin-top: -25px;
        font-size: 14px
    }
    .select {
        padding: 0 15px;
        /*width: 80px;*/
        text-align: center
    }
    .active{
        box-shadow: 0 2px 0 rgba(97,167,255,1);
        color:rgba(97,167,255,1);
    }
    .tag-box {
            width: 288px;
            min-height: 30px;
            border-radius: 5px;
            border: 1px solid #DCDFE6;
            padding: 0 15px
        }
</style>